let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j3PEW")).then(() => parcelRequire('bem9x'));